<template>
    <div id="contents" class="contents contents-other">
        <div class="breadcrumb">
            <ul>
                <li><router-link :to="{name: 'Index'}">TOP</router-link></li>
                <li>Copyright</li>
            </ul>
        </div>

        <h1 class="ttl">Copyright</h1>

        <div class="box-section -grayBgStart">
            <div class="inner">
                <h3 class="ttlSub">Using the Content of the Japan Heritage Official Website</h3>
                <p class="para">This website is produced by the Japan National Tourism Organization and contents provided by Agency for Cultural Affairs,
                        Government of Japan. Information made available on the Japan Heritage Official Website (<a href="https://www.japan.travel/japan-heritage/" target="_blank">https://www.japan.travel/japan-heritage/</a>) (hereinafter referred to as the "Content") may be freely used, copied, publicly transmitted,
                        translated or otherwise modified on condition that the user complies with provisions from 1) to 4) below,
                        with the exception of the Content where other terms of use shall be applied. Commercial use of the Content is also permitted.<br><br>
                        Use of the Content constitutes agreement by the user with these terms of use for using the Content.  (Hereinafter referred to as "Terms of Use").</p>

                <h4 class="ttlSubSub">1) No Infringement of Third Party's Rights</h4>
                <p class="para">a. In some cases, a Third Party (refers to a party other than the state) may hold copyrights or other rights to a part of the Content.
                        For Content where a Third Party holds copyrights or other rights (e.g. portrait rights in a photograph, publicity rights, etc.),
                        it is the responsibility of the user to obtain consent for use from the Third Party unless there is explicit indication that the rights have already been cleared.<br><br>

                        b. If a Third Party holds rights to a part of the Content, the said fact may be directly or indirectly stated or indicated through source citations, etc.,
                        but in some cases the part of the Content to which the Third Party holds the rights may not be identified or explicitly stated.
                        It is the responsibility of the user to confirm the rights pertaining to use of the Content.<br><br>

                        c. The user shall comply with the terms and conditions of the source provider for Content obtained through API (Application Programming Interface) links to external databases, etc.<br><br>

                        d. Even if a Third Party holds copyrights or other rights to the Content, some use of the Content, such as quoting,
                        may be allowed without the consent of the holder of copyrights, etc., under the Copyright Act of Japan.</p>

                <h4 class="ttlSubSub">2) Governing Law and Jurisdiction by Agreement</h4>
                <p class="para">a. The Terms of Use shall be governed by and construed in accordance with the laws of Japan.<br><br>

                        b. In case of disputes relating to the use of the Content based on the Terms of Use and the Terms of Use,
                        the user agrees that the district court with jurisdiction over the location of the organization that
                        has published the disputed Content/Terms of Use shall be the exclusive court of first instance.</p>

                <h4 class="ttlSubSub">3) Disclaimer</h4>
                <p class="para">a. The state bears absolutely no responsibility for any act taken by the user involving the use of the Content (including use of information based on edited Content).<br><br>
                        b. The Content may be modified, moved or deleted without prior notice.</p>

                <h4 class="ttlSubSub">4) Other</h4>
                <p class="para">a. The Terms of Use do not limit such types of uses allowed under Copyright Act of Japan as citation.</p>

                <h3 class="ttlSub">Links to the Japan Heritage Official Website</h3>
                <p class="para">In principle, links to the Japan Heritage Official Website may be made without prior permission.
                        However, please observe the following points. Linking to particular Content should also be conducted observing these points:<br><br>
                        a. Please state explicitly that the link is to the Japan Heritage Official Website; and<br><br>
                        b. Please do not link to the Japan Heritage Official Website within the window or frame of another website.</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Copyright",
        created: function() {
            document.title = 'Copyright | Japan Heritage Official Site'
        }
    }
</script>

<style src="./Copyright.scss" lang="scss" scoped />
